export const UpdateImageValidation = (formData) => {
    const errors = {};
    debugger;
    if (!formData.File && !formData.FileName) {
        errors.File = 'This field is required';
    }

    return errors;
};
